import {Local} from './Local';

export const ar: Local = {
  translation: {
    logout: 'تسجيل الخروج',
  },
};
